import { render, staticRenderFns } from "./retiradas-rede.vue?vue&type=template&id=1c404fd6&scoped=true&"
import script from "./retiradas-rede.vue?vue&type=script&lang=js&"
export * from "./retiradas-rede.vue?vue&type=script&lang=js&"
import style0 from "./retiradas-rede.vue?vue&type=style&index=0&id=1c404fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c404fd6",
  null
  
)

export default component.exports